var map = {
	"./Canvas.vue": "DCn3",
	"./Gallery.vue": "MP2d",
	"./ModeAndViewportToolbar.vue": "0nm/",
	"./ToolbarTop.vue": "EWpz",
	"./VersionActions.vue": "7QU1",
	"./bootstrapper.js": "od4y"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "MREV";